exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".subcategory .blockRow{padding:.125rem;padding-left:.75rem}a.material-icons.action-icon{text-decoration:none;color:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-f55d1132!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/DayView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-f55d1132!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/DayView.vue
// module chunks = 0